import React, { useEffect, useRef, useState } from "react";
import { useCountUp } from "react-countup";
import { Text } from "@pancakeswap-libs/uikit";

interface CardValueProps {
  value: number;
  decimals?: number;
  fontSize?: string;
  prefix?: string;
  fontWeigt?: number;
}

const CardValue: React.FC<CardValueProps> = ({
  value,
  fontSize,
  prefix,
  fontWeigt,
}) => {
  const { update } = useCountUp({
    start: 0,
    end: value,
    duration: 1,
    separator: ",",
  });

  const updateValue = useRef(update);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!Number.isNaN(value) && value !== undefined) {
      setLoading(true);
    }

    updateValue.current(value);
  }, [value, updateValue]);

  return (
    <Text
      bold
      style={{
        marginBottom: "10px",
        fontWeight: fontWeigt || 100,
        fontSize: fontSize || "20px",
      }}
    >
      {!loading ? (
        <div className="loader" />
      ) : (
        <>
          {prefix}
          {value?.toLocaleString()}
        </>
      )}
    </Text>
  );
};

export default CardValue;
